var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('vue-plyr',{class:_vm.marginTop,attrs:{"options":{ controls: _vm.controls }}},[_c('video',{attrs:{"data-poster":_vm.dataPoster}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4","size":"1080"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }